/**
 * 動画生成で「ユーザー向けの専用文言を出すべき失敗」を表すエラー。
 *
 * 汎用の失敗は Error のまま投げ、UI 側は errorMessages.videoGenerationFailed で扱う。
 * ここに列挙したコードだけが、それぞれ専用の文言に分岐する。
 * このエラー自体は文言を持たず、どの errorMessages を引くかの判別だけを担う。
 */
export type VideoGenerationErrorCode = 'WEBCODECS_UNSUPPORTED' | 'AAC_ENCODER_UNAVAILABLE';

export class VideoGenerationError extends Error {
  readonly code: VideoGenerationErrorCode;

  constructor(code: VideoGenerationErrorCode, message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'VideoGenerationError';
    this.code = code;
  }
}

export function isVideoGenerationError(error: unknown): error is VideoGenerationError {
  return error instanceof VideoGenerationError;
}
